<template>
  <div id="all">
    <div id="ajax-upload">
      <main id="main">
        <div class="container">
          <div class="auth-box">
            <div class="logo">
              <IconLogo/>
            </div>
            <div class="auth-form">
              <p class="h2 title line ">Manage Event</p>
              <div :class="loading ? 'loading' : ''">
                <div class="terminal-col" v-if="event && !message && !loading">
                  <h3>Terminal: </h3>
                  <p>{{event.name}} - <span class="terminal-id">{{event.core_module_id}}</span></p>
                  <h3>Location: </h3>
                  <p>{{event.location}}</p>
                  <h3>Date: </h3>
                  <p>{{event.start_time}} - {{event.finish_time}}</p>
                  <h3>Client: </h3>
                  <p>{{event.client.company}} ({{event.client.email}})</p>
                </div>

                <button type="button" class="btn success small" @click.prevent="openPopup(true)" v-if="event && !message && !loading">
                  <icon-base width="20" height="21" viewBox="0 0 28 29"><icon-success/></icon-base>
                  <span>Accept</span>
                </button>
                <button class="btn danger will-delete-btn" @click.prevent="openPopup(false)" v-if="event && !message && !loading">
                  <icon-base width="20" height="20" viewBox="0 0 20 20"><icon-cross-2 color="white"/></icon-base>
                  <span>DECLINE</span>
                </button>
                <teleport to="#popup-box .container" v-if="openedPopup">
                  <div class="popup visible" id="cancel-popup">
                    <div class="popup-box">
                      <p class="h2 title">Are you sure you want to {{accept ? 'accept' : 'decline'}} this event?</p>
                      <div class="buttons-box">
                        <span class="btn success no-bg" @click="closeDialog">
                          <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-deny/></icon-base>
                          <span>NO</span>
                        </span>
                        <span class="btn" :class="accept ? 'success small' : 'danger will-delete-btn'"  @click.prevent="actionClick(accept)">
                          <icon-base width="20" height="21" :viewBox="accept ? '0 0 28 29' : '0 0 20 21'"><component :is="accept ? 'icon-success' : 'icon-delete'"/></icon-base>
                            <span>{{accept ? 'Accept' : 'Decline'}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </teleport>
                <h3 v-if="message">{{message}}</h3>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import IconLogo from "./common/icons/IconLogo";
import {toggleBodyClass} from "../common"
import {mapMutations} from "vuex"
import IconBase from "./common/IconBase";
import IconSuccess from "./common/icons/IconSuccess";
import IconCross2 from "./common/icons/IconCross2";
import IconDeny from "./common/icons/IconDeny";
import IconDelete from "./common/icons/IconDelete";

export default {
    name: 'ManageEventStatus',
    components: {IconDelete, IconDeny, IconCross2, IconSuccess, IconBase, IconLogo},

    data() {
        return {
            event: null,
            eventToken: '',
            message: '',
            loading: true,
            accept: true,
            openedPopup: false
        }
    },

    mounted() {
        toggleBodyClass('addClass', 'auth-page');
        toggleBodyClass('addClass', 'password-recovery');
        this.eventToken = this.$route.query.token;
        if (!this.eventToken) {
            this.$router.push('login')
        }
        this.getEvent();
    },
    unmounted() {
        toggleBodyClass('removeClass', 'auth-page');
        toggleBodyClass('removeClass', 'password-recovery');
    },

    methods: {
        ...mapMutations(['pushNotification']),
        closeDialog() {
            this.openedPopup = false;
            let root = document.getElementsByTagName( 'html' )[0];
            root.classList.remove('opened-popup')
        },
        openPopup(value) {
            this.openedPopup = true;
            this.accept = value;
            let root = document.getElementsByTagName( 'html' )[0];
            root.classList.add('opened-popup')
        },
        actionClick(value) {
            this.loading = true;
            this.closeDialog();
            return new Promise((resolve) => {
                setTimeout(() => {
                    //axios.defaults.headers.post['X-CSRF-Token'] = this.token;
                    axios.post('/api/events/set-insamart-status', {id: this.event.id, token: this.eventToken, value: value})
                        .then((response) => {
                            if (response.data.success) {
                                this.message = response.data.message;
                            }
                            this.loading = false;
                        })
                        .catch((error) => {
                            console.log(error)
                            //this.$store.dispatch('errorHandler', error);
                            this.loading = false;
                        });
                    resolve()
                }, 1000);
            });

        },
        getEvent() {
            this.loading = true;
            return new Promise((resolve) => {
                setTimeout(() => {
                    axios.get('/api/events/get-event-by-token', {params: {token: this.eventToken}})
                        .then((response) => {
                            if (response.data.success) {
                                this.event = response.data.event;
                            } else {
                                this.message = response.data.message;
                                /*this.pushNotification({
                                    message: response.data.message,
                                    type: "error",
                                } , { root: true });*/
                            }
                            this.loading = false;
                        })
                        .catch((error) => {
                            console.log(error)
                            //this.$store.dispatch('errorHandler', error);
                            this.loading = false;
                        });
                    resolve()
                }, 1000);
            });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loading {
    background: url("../../public/i/loader.svg") no-repeat 50% 50%/40px auto;
    height: 480px;
  }
</style>
